"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linearTickPositions = void 0;
// (C) 2007-2020 GoodData Corporation
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function linearTickPositions(Highcharts) {
    var wrap = Highcharts.wrap;
    var YAXIS = "yAxis";
    var HEATMAP = "heatmap";
    wrap(Highcharts.Axis.prototype, "getLinearTickPositions", function (proceed) {
        // TODO fix this, I'm not brave enough to touch this...
        // eslint-disable-next-line prefer-rest-params
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        var _a = this, categories = _a.categories, coll = _a.coll, type = _a.chart.options.chart;
        var isYAxis = coll === YAXIS;
        var isHeatmap = type === HEATMAP;
        var tickPositions = proceed.apply(this, args);
        var noTicks = tickPositions.length;
        var lastIndex = noTicks > 0 ? tickPositions[noTicks - 1] : 0;
        // on Yaxis of heatmap, if lastIndex is out of category indcies
        // remove the last tick to remove the empty space on top of heatmap
        if (isHeatmap && isYAxis && categories && lastIndex >= categories.length) {
            tickPositions.pop();
        }
        return tickPositions;
    });
}
exports.linearTickPositions = linearTickPositions;
//# sourceMappingURL=linearTickPositions.js.map